module.exports = __webpack_public_path__ + "main/assets/public/player-bars/bars.5c186355091ceeed.svg";